import { useLocation, useNavigate } from "react-router-dom";
import { Home, Plus, User, Share2, Grid3X3 } from "lucide-react";

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path) => location.pathname === path;
  
  if (["/login", "/register"].includes(location.pathname)) return null;

  return (
    <nav className="bottom-nav glass-nav safe-bottom" data-testid="bottom-nav">
      <div className="max-w-md mx-auto flex justify-around py-2">
        <button
          onClick={() => navigate("/")}
          className={`bottom-nav-item ${isActive("/") ? "active" : ""}`}
          data-testid="nav-home"
        >
          <Home size={24} />
          <span className="text-xs">Inicio</span>
        </button>
        <button
          onClick={() => navigate("/gallery")}
          className={`bottom-nav-item ${isActive("/gallery") ? "active" : ""}`}
          data-testid="nav-gallery"
        >
          <Grid3X3 size={24} />
          <span className="text-xs">Galería</span>
        </button>
        <button
          onClick={() => navigate("/add")}
          className={`bottom-nav-item ${isActive("/add") ? "active" : ""}`}
          data-testid="nav-add"
        >
          <Plus size={24} />
          <span className="text-xs">Añadir</span>
        </button>
        <button
          onClick={() => navigate("/share")}
          className={`bottom-nav-item ${isActive("/share") ? "active" : ""}`}
          data-testid="nav-share"
        >
          <Share2 size={24} />
          <span className="text-xs">Compartir</span>
        </button>
        <button
          onClick={() => navigate("/profile")}
          className={`bottom-nav-item ${isActive("/profile") ? "active" : ""}`}
          data-testid="nav-profile"
        >
          <User size={24} />
          <span className="text-xs">Perfil</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
